import { TeamPlanEditorContent } from 'app/frontend/base/pages/TeamDashboard/subpages/TeamPlans/components/TeamPlanEditor'

const UserPlanEditor = () => {
  return (
    <TeamPlanEditorContent
      owner={{ ownerType: 'user' }}
      basePath='/profile/plans'
      planListPathPrefix='/profile'
      rosterMemberships={[]}
      canEdit={true}
      showViewers={false}
      showRosterImport={false}
    />
  )
}

export default UserPlanEditor
